import React, { FC, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import MyPageLayout from '../../components/Layouts/MyPage/MyPageLayout.index';
import VisitorRegisterPolicyModal from './components/VisitorRegisterPolicyModal.index';
import { VisitorRegisterType, ContentsInfo } from '../../store/reducers/visitorRegister/visitorRegisterReducer';
import { VisitorRegisterConfirmType } from '../../store/reducers/visitorRegister/visitorRegisterConfirmReducer';
import {
  GET_VISITOR_RESERVATION_CHECK_INITIAL,
  GET_VISITOR_RESERVATION_CHECK_REQUEST,
  SCHEDULE_DISPATCH,
  VISITOR_REGISTER_CONFIRM_DISPATCH,
  VISITOR_REGISTER_CONFIRM_DISPATCH_INIT,
  VISITOR_REGISTER_DISPATCH_INIT,
} from '../../store/actions';

import { RootState } from '../../store/reducers';

const VisitorRegister: FC = () => {
  const clubId = Number(sessionStorage.getItem('scheduleQueryParam_clubCode'));
  const [isPolicyModalOpen, setIsPolicyModalOpen] = useState(false);

  const { contentsInfo } = useSelector<RootState, VisitorRegisterType>((state: any) => state.visitorRegister);
  const { visitorRegisterConfirm, visitorBlackListCheckResult } = useSelector<RootState, VisitorRegisterConfirmType>(
    (state: any) => state.visitorRegisterConfirm,
  );
  const [contents, setContents] = useState<ContentsInfo>();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [visitorSei, setVisitorSei] = useState('');
  const [visitorMei, setVisitorMei] = useState('');
  const [birthday, setBirthday] = useState('');
  const [sex, setSex] = useState('1');
  const [emailUsername, setEmailUsername] = useState('');
  const [emailDomain, setEmailDomain] = useState('');
  const [telephone, setTelephone] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [isNextButtonEnable, setIsNextButtonEnable] = useState(false);
  const [visitorSeiMessage, setVisitorSeiMessage] = useState('');
  const [visitorMeiMessage, setVisitorMeiMessage] = useState('');
  const [birthdayMessage, setBirthdayMessage] = useState('');
  const [mailMessage, setMailMessage] = useState('');
  const [telephoneMessage, setTelephoneMessage] = useState('');
  const [blackListCheckMessage, setBlackListCheckMessage] = useState('');
  const [checkMessage, setCheckMessage] = useState('');

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch({
      type: GET_VISITOR_RESERVATION_CHECK_INITIAL,
    });
    setIsModalOpen(false);
    setBlackListCheckMessage('');
    setCheckMessage('');

    window.scrollTo(0, 0);
    if (contentsInfo.contentsId && contentsInfo.contentsId !== 0) {
      setContents({
        contentsId: contentsInfo.contentsId,
        eqsId: contentsInfo.eqsId,
        contentsDate: contentsInfo.contentsDate || '',
        startTime: contentsInfo.startTime || '',
        endTime: contentsInfo.endTime || '',
        companion: contentsInfo.companion,
        contentsName: contentsInfo.contentsName || '',
        shopName: contentsInfo.shopName || '',
        eqsName: contentsInfo.eqsName || '',
        spaceName: contentsInfo.spaceName || '',
        isAnnex: contentsInfo.isAnnex,
        clubAddress: contentsInfo.clubAddress || '',
      });
    } else {
      const cacheObjStr = sessionStorage.getItem('visitorRegister_cacheObj');
      if (cacheObjStr) {
        const cacheObj = JSON.parse(cacheObjStr);
        if (cacheObj && (!cacheObj.contentsId || cacheObj.contentsId === 0)) {
          dispatch({
            type: VISITOR_REGISTER_DISPATCH_INIT,
          });
          history.push('/');
        } else {
          setContents({
            contentsId: cacheObj.contentsId,
            eqsId: cacheObj.eqsId,
            contentsDate: cacheObj.contentsDate || '',
            startTime: cacheObj.startTime || '',
            endTime: cacheObj.endTime || '',
            companion: cacheObj.companion,
            contentsName: cacheObj.contentsName || '',
            shopName: cacheObj.shopName || '',
            eqsName: cacheObj.eqsName || '',
            spaceName: cacheObj.spaceName || '',
            isAnnex: cacheObj.isAnnex,
            clubAddress: cacheObj.clubAddress || '',
          });
        }
      }
    }

    return () => {
      dispatch({
        type: GET_VISITOR_RESERVATION_CHECK_INITIAL,
      });
      setIsModalOpen(false);
      setBlackListCheckMessage('');
      setCheckMessage('');
    };
  }, []);

  useEffect(() => {
    if (contents && contents.contentsId && contents.contentsId !== 0) {
      if (contentsInfo && contentsInfo.contentsId) {
        const cacheObj = {
          contentsId: contentsInfo.contentsId,
          eqsId: contentsInfo.eqsId,
          contentsDate: contentsInfo.contentsDate || '',
          startTime: contentsInfo.startTime || '',
          endTime: contentsInfo.endTime || '',
          companion: contentsInfo.companion,
          contentsName: contentsInfo.contentsName || '',
          shopName: contentsInfo.shopName || '',
          eqsName: contentsInfo.eqsName || '',
          spaceName: contentsInfo.spaceName || '',
          isAnnex: contentsInfo.isAnnex,
          clubAddress: contentsInfo.clubAddress || '',
        };
        const jsonString = JSON.stringify(cacheObj);
        sessionStorage.setItem('visitorRegister_cacheObj', jsonString);
      }
      if (visitorRegisterConfirm) {
        setLastName(visitorRegisterConfirm.lastName);
        setFirstName(visitorRegisterConfirm.firstName);
        setVisitorSei(visitorRegisterConfirm.visitorSei);
        setVisitorMei(visitorRegisterConfirm.visitorMei);
        setBirthday(visitorRegisterConfirm.birthday);
        setSex(visitorRegisterConfirm.sex);
        setEmailUsername(visitorRegisterConfirm.emailUsername);
        setEmailDomain(visitorRegisterConfirm.emailDomain);
        setTelephone(visitorRegisterConfirm.telephone);
        setIsChecked(visitorRegisterConfirm.isChecked);
      } else {
        setLastName('');
        setFirstName('');
        setVisitorSei('');
        setVisitorMei('');
        setBirthday('');
        setSex('1');
        setEmailUsername('');
        setEmailDomain('');
        setTelephone('');
        setIsChecked(false);
      }
    }
  }, [contents, visitorRegisterConfirm]);

  useEffect(() => {
    setIsNextButtonEnable(
      visitorSei !== '' &&
        visitorMei !== '' &&
        birthday !== '' &&
        sex !== '' &&
        emailUsername !== '' &&
        emailDomain !== '' &&
        telephone !== '' &&
        isChecked,
    );
  }, [firstName, lastName, visitorSei, visitorMei, birthday, sex, emailUsername, emailDomain, telephone, isChecked]);

  const handleBirthdayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBirthdayMessage('');
    const numericValue = e.target.value.replace(/[^0-9]/g, '');
    if (numericValue.length > 8) {
      return;
    }
    setBirthday(numericValue);
  };

  const handleEmailUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMailMessage('');
    if (e.target.value.length > 60) {
      return;
    }
    setEmailUsername(e.target.value);
  };

  const handleEmailDomainChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMailMessage('');
    if (e.target.value.length > 60) {
      return;
    }
    setEmailDomain(e.target.value);
  };

  const handleTelephoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTelephoneMessage('');
    const numericValue = e.target.value.replace(/[^0-9]/g, '');
    if (numericValue.length > 11) {
      return;
    }
    setTelephone(e.target.value);
  };

  const handleGoBack = () => {
    dispatch({
      type: VISITOR_REGISTER_DISPATCH_INIT,
    });
    dispatch({
      type: VISITOR_REGISTER_CONFIRM_DISPATCH_INIT,
    });
    dispatch({
      type: SCHEDULE_DISPATCH,
      showPopFlag: true,
    });
    history.push('/reservation/schedule');
  };

  const getLastDayFromMonth = (index: number) => {
    const days = [0, 31, Number(birthday.substring(0, 4)) % 4 === 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return days[index];
  };

  const checkBornDate = (bday: string) => {
    let isValid = true;
    const month = Number(bday.substring(4, 6));
    const date = Number(bday.substring(6));
    if (date > getLastDayFromMonth(month)) {
      isValid = false;
    }
    return isValid;
  };

  const checkBirthday = (bday: string) => {
    if (bday !== '' && bday !== null && bday?.length === 8) {
      const bdayStyled = `${bday.substring(0, 4)}/${bday.substring(4, 6)}/${bday.substring(6)}`;
      const checkRegex = /^(19|20)\d{2}\/(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])$/;
      if (checkRegex.test(bdayStyled)) {
        if (checkBornDate(bday)) {
          return true;
        }
      }
    }
    return false;
  };

  const isPhoneCheck = (mobile: string): boolean => {
    if (
      mobile !== '' &&
      mobile !== null &&
      (mobile.length === 10 || mobile.length === 11) &&
      mobile.match(/^[0-9]+$/) != null
    ) {
      return true;
    }
    return false;
  };

  const checkMail = (email: string) => {
    const re =
      /^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+(\.[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const getStrLength = (str: string): number => {
    let result = 0;
    for (let i = 0; i < str.length; i += 1) {
      const chr = str.charCodeAt(i);
      if (
        (chr >= 0x00 && chr < 0x81) ||
        chr === 0xf8f0 ||
        (chr >= 0xff61 && chr < 0xffa0) ||
        (chr >= 0xf8f1 && chr < 0xf8f4)
      ) {
        // 半角文字の場合は1を加算
        result += 1;
      } else {
        // それ以外の文字の場合は2を加算
        result += 2;
      }
    }
    // 結果を返す
    return result;
  };

  const isHiraganaCheck = (ch: string): boolean => {
    let k = 0;
    for (let i = 0; i < ch.length; i += 1) {
      if (
        (ch[i] >= '\u3040' && ch[i] <= '\u309f') ||
        ch[i] === '\u3000' ||
        ch[i] === '\u0020' ||
        ch[i] === '\u30f4' ||
        ch[i] === '\u30fc'
      ) {
        k += 1;
      }
    }
    if (k === ch.length) {
      return true;
    }
    return false;
  };

  const handleNext = () => {
    let err = false;
    if (!checkBirthday(birthday)) {
      err = true;
      setBirthdayMessage('生年月日が不正です。');
    }

    const replacedVisitorSei = visitorSei.replace(/ゔ/g, 'ヴ');
    if (!isHiraganaCheck(replacedVisitorSei)) {
      err = true;
      setVisitorSeiMessage('姓(ふりがな)はひらがなで入力してください。');
    } else if (getStrLength(replacedVisitorSei) > 19) {
      err = true;
      setVisitorSeiMessage('姓(ふりがな)は全角9文字(半角19文字)以内で入力してください。');
    } else if (replacedVisitorSei.trim().length === 0) {
      err = true;
      setVisitorSeiMessage('姓(ふりがな)はひらがなで入力してください。');
    }

    const replacedVisitorMei = visitorMei.replace(/ゔ/g, 'ヴ');
    if (!isHiraganaCheck(replacedVisitorMei)) {
      err = true;
      setVisitorMeiMessage('名(ふりがな)はひらがなで入力してください。');
    } else if (getStrLength(replacedVisitorMei) > 19) {
      err = true;
      setVisitorMeiMessage('名(ふりがな)は全角9文字(半角19文字)以内で入力してください。');
    } else if (replacedVisitorMei.trim().length === 0) {
      err = true;
      setVisitorMeiMessage('名(ふりがな)はひらがなで入力してください。');
    }

    const emailAddress = `${emailUsername}@${emailDomain}`;
    if (!checkMail(emailAddress)) {
      err = true;
      setMailMessage('メールアドレスが不正です。');
    } else if (
      emailUsername.trim().length === 0 ||
      emailDomain.trim().length === 0 ||
      !(emailAddress.length <= 60 && emailAddress.length === getStrLength(emailAddress))
    ) {
      err = true;
      setMailMessage('メールアドレスは「@」を含めて60文字以内で入力してください。');
    }
    if (!isPhoneCheck(telephone)) {
      err = true;
      setTelephoneMessage('電話番号が不正です。');
    }
    if (err) {
      return;
    }

    setIsModalOpen(false);
    setBlackListCheckMessage('');
    setCheckMessage('');

    dispatch({
      type: GET_VISITOR_RESERVATION_CHECK_REQUEST,
      clubId,
      contentsId: contents?.contentsId || 0,
      eqsId: contents?.eqsId || 0,
      contentsDate: contents?.contentsDate || '',
      startTime: contents?.startTime || '',
      endTime: contents?.endTime || '',
      fullLastName: lastName,
      fullFirstName: firstName,
      visitorSei: replacedVisitorSei,
      visitorMei: replacedVisitorMei,
      mail: emailAddress,
      birthday,
      tel: telephone,
      sex: Number(sex),
      history,
    });
  };

  useEffect(() => {
    if (visitorBlackListCheckResult.isLoaded) {
      if (visitorBlackListCheckResult.result === 0) {
        const replacedVisitorSei = visitorSei.replace(/ゔ/g, 'ヴ');
        const replacedVisitorMei = visitorMei.replace(/ゔ/g, 'ヴ');
        dispatch({
          type: VISITOR_REGISTER_CONFIRM_DISPATCH,
          visitorInfo: {
            contentsId: contents?.contentsId || 0,
            eqsId: contents?.eqsId || 0,
            contentsDate: contents?.contentsDate || '',
            startTime: contents?.startTime || '',
            endTime: contents?.endTime || '',
            companion: contents?.companion || 0,
            firstName,
            lastName,
            visitorSei: replacedVisitorSei,
            visitorMei: replacedVisitorMei,
            birthday,
            sex,
            emailUsername,
            emailDomain,
            telephone,
            isChecked,
            contentsName: contents?.contentsName,
            shopName: contents?.shopName,
            eqsName: contents?.eqsName,
            spaceName: contents?.spaceName,
            isAnnex: contents?.isAnnex || false,
            clubAddress: contents?.clubAddress || '',
          },
        });
        history.push('/register/confirm');
      } else if (visitorBlackListCheckResult.result === 3) {
        setBlackListCheckMessage(visitorBlackListCheckResult.message || '');
        setIsModalOpen(true);
      } else if (visitorBlackListCheckResult.result === 1) {
        setCheckMessage(visitorBlackListCheckResult.message || '');
      }
    }
  }, [visitorBlackListCheckResult.isLoaded]);

  const handleOpenPolicyModal = () => {
    setIsPolicyModalOpen(true);
  };

  const handleClosePolicyModal = () => {
    setIsPolicyModalOpen(false);
  };

  /**
   * お名前ー姓入力時の処理
   */
  const onChangeLastName = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    // 文字数カウント（全角文字は2、半角文字は1としてカウント）
    let charCount = 0;
    for (let i = 0; i < value.length; i += 1) {
      const char = value.charAt(i);
      // 全角文字判定（中文、日文汉字、ひらがな、カタカナ、全角英数字など）
      if (/[\u3400-\u4DBF\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF]/.test(char)) {
        charCount += 2; // 全角文字は2としてカウント
      } else {
        charCount += 1; // 半角文字は1としてカウント
      }
    }

    if (charCount <= 20) {
      setLastName(value);
    }
  }, []);

  /**
   * お名前ー名入力時の処理
   */
  const onChangeFirstName = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    // 文字数カウント（全角文字は2、半角文字は1としてカウント）
    let charCount = 0;
    for (let i = 0; i < value.length; i += 1) {
      const char = value.charAt(i);
      // 全角文字判定（中文、日文汉字、ひらがな、カタカナ、全角英数字など）
      if (/[\u3400-\u4DBF\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF]/.test(char)) {
        charCount += 2; // 全角文字は2としてカウント
      } else {
        charCount += 1; // 半角文字は1としてカウント
      }
    }

    if (charCount <= 20) {
      setFirstName(value);
    }
  }, []);

  /**
   * ふりがなー姓入力時の処理
   */
  const onChangeVisitorSei = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setVisitorSeiMessage('');
    const { value } = e.target;
    // 文字数カウント（全角文字は2、半角文字は1としてカウント）
    let charCount = 0;
    for (let i = 0; i < value.length; i += 1) {
      const char = value.charAt(i);
      // 全角文字判定（中文、日文汉字、ひらがな、カタカナ、全角英数字など）
      if (/[\u3400-\u4DBF\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF]/.test(char)) {
        charCount += 2; // 全角文字は2としてカウント
      } else {
        charCount += 1; // 半角文字は1としてカウント
      }
    }

    if (charCount <= 20) {
      setVisitorSei(value);
    }
  }, []);

  /**
   * ふりがなー名入力時の処理
   */
  const onChangeVisitorMei = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setVisitorMeiMessage('');
    const { value } = e.target;
    // 文字数カウント（全角文字は2、半角文字は1としてカウント）
    let charCount = 0;
    for (let i = 0; i < value.length; i += 1) {
      const char = value.charAt(i);
      // 全角文字判定（中文、日文汉字、ひらがな、カタカナ、全角英数字など）
      if (/[\u3400-\u4DBF\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF]/.test(char)) {
        charCount += 2; // 全角文字は2としてカウント
      } else {
        charCount += 1; // 半角文字は1としてカウント
      }
    }

    if (charCount <= 20) {
      setVisitorMei(value);
    }
  }, []);

  const onModalConfirm = () => {
    const replacedVisitorSei = visitorSei.replace(/ゔ/g, 'ヴ');
    const replacedVisitorMei = visitorMei.replace(/ゔ/g, 'ヴ');
    dispatch({
      type: VISITOR_REGISTER_CONFIRM_DISPATCH,
      visitorInfo: {
        contentsId: contents?.contentsId || 0,
        eqsId: contents?.eqsId || 0,
        contentsDate: contents?.contentsDate || '',
        startTime: contents?.startTime || '',
        endTime: contents?.endTime || '',
        companion: contents?.companion || 0,
        firstName,
        lastName,
        visitorSei: replacedVisitorSei,
        visitorMei: replacedVisitorMei,
        birthday,
        sex,
        emailUsername,
        emailDomain,
        telephone,
        isChecked,
        contentsName: contents?.contentsName,
        shopName: contents?.shopName,
        eqsName: contents?.eqsName,
        spaceName: contents?.spaceName,
        isAnnex: contents?.isAnnex || false,
        clubAddress: contents?.clubAddress,
      },
    });
    history.push('/register/confirm');
  };

  const onModalCancel = () => {
    setIsModalOpen(false);
    setBlackListCheckMessage('');
    setCheckMessage('');
  };

  return (
    <>
      <MyPageLayout>
        <main className="main-layout l-main">
          <section className="p-title-area">
            <p className="c-title">予約情報を入力してください</p>
          </section>
          <section className="p-content-area u-gap50">
            <div className="p-content-area__column p-content-area__column--width922 u-gap50 u-sp-gap30">
              <p className="c-read">
                体験見学のご参加には以下の予約情報の入力が必要です。
                <br />
                入力されたメールアドレスへ、ご予約内容を送信いたします。
              </p>
              <div className="p-content-area__column u-gap20 u-sp-gap40">
                {/* インプット */}
                <div className="p-form-item p-form-item--row">
                  <div className="p-form-item__label">お名前</div>
                  <div className="p-form-item__input-container">
                    <div className="p-form-item__input-group p-form-item__input-group--full">
                      <div className="p-form-item__sub-label">姓</div>
                      <div className="c-input">
                        <input
                          id="last-name"
                          className="c-input__window"
                          type="text"
                          placeholder="山田"
                          value={lastName}
                          onChange={onChangeLastName}
                          maxLength={20}
                        />
                      </div>
                    </div>
                    <div className="p-form-item__input-group p-form-item__input-group--full">
                      <div className="p-form-item__sub-label">名</div>
                      <div className="c-input">
                        <input
                          id="first-name"
                          className="c-input__window"
                          type="text"
                          placeholder="花子"
                          value={firstName}
                          onChange={onChangeFirstName}
                          maxLength={20}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* / インプット */}
                {/* インプット */}
                <div className="p-form-item p-form-item--row">
                  <div className="p-form-item__label">
                    ふりがな<span className="p-form-item__required">必須</span>
                  </div>
                  <div className="p-form-item__input-container">
                    <div className="p-form-item__input-group p-form-item__input-group--full">
                      <div className="p-form-item__sub-label">せい</div>
                      <div className="c-input">
                        <input
                          id="last-name-furigana"
                          className="c-input__window"
                          type="text"
                          placeholder="やまだ"
                          value={visitorSei}
                          onChange={onChangeVisitorSei}
                          maxLength={20}
                        />
                      </div>
                    </div>
                    <div className="p-form-item__input-group p-form-item__input-group--full">
                      <div className="p-form-item__sub-label">めい</div>
                      <div className="c-input">
                        <input
                          id="first-name-furigana"
                          className="c-input__window"
                          type="text"
                          placeholder="はなこ"
                          value={visitorMei}
                          onChange={onChangeVisitorMei}
                          maxLength={20}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="p-form-item__label" style={{ height: 'auto' }} />
                  <div className="p-form-item__input-container">
                    <div className="p-form-item__input-group p-form-item__input-group--full">
                      <div className="p-form-item__sub-label" />
                      <div
                        style={{
                          color: '#d60035',
                          textAlign: 'start',
                          width: '100%',
                          whiteSpace: 'break-spaces',
                          wordBreak: 'break-all',
                        }}
                        className="p-form-item__input-container"
                      >
                        {visitorSeiMessage}
                      </div>
                    </div>
                    <div className="p-form-item__input-group p-form-item__input-group--full">
                      <div className="p-form-item__sub-label" />
                      <div
                        style={{
                          color: '#d60035',
                          textAlign: 'start',
                          width: '100%',
                          whiteSpace: 'break-spaces',
                          wordBreak: 'break-all',
                        }}
                        className="p-form-item__input-container"
                      >
                        {visitorMeiMessage}
                      </div>
                    </div>
                  </div>
                </div>
                {/* / インプット */}
                {/* インプット */}
                <div className="p-form-item p-form-item--row">
                  <div className="p-form-item__label">
                    生年月日<span className="p-form-item__required">必須</span>
                  </div>
                  <div className="c-input c-input--width146">
                    <input
                      id="birthdate"
                      className="c-input__window"
                      type="text"
                      placeholder="00000000"
                      value={birthday}
                      onChange={handleBirthdayChange}
                      maxLength={8}
                    />
                  </div>
                  <div className="p-form-item__label" style={{ height: 'auto' }} />
                  <div
                    style={{
                      color: '#d60035',
                      textAlign: 'start',
                      width: '100%',
                      whiteSpace: 'break-spaces',
                      wordBreak: 'break-all',
                    }}
                  >
                    {birthdayMessage}
                  </div>
                  <div className="p-form-item__label" style={{ height: 'auto' }} />
                  <p className="p-form-item__note">※記入例：1991年5月18日→19910518</p>
                </div>
                {/* / インプット */}
                {/* ラジオボタン */}
                <div className="p-form-item p-form-item--row">
                  <div className="p-form-item__label">
                    性別<span className="p-form-item__required">必須</span>
                  </div>
                  <div className="p-form-item__input-container u-gap20">
                    <div className="p-form-item__input-group">
                      <div className="c-radio-button">
                        <input
                          id="gender-male"
                          className="c-radio-button__input"
                          type="radio"
                          name="gender"
                          value="1"
                          checked={sex === '1'}
                          onChange={(e) => setSex(e.target.value)}
                        />
                        男性
                      </div>
                    </div>
                    <div className="p-form-item__input-group">
                      <div className="c-radio-button">
                        <input
                          id="gender-female"
                          className="c-radio-button__input"
                          type="radio"
                          name="gender"
                          value="2"
                          checked={sex === '2'}
                          onChange={(e) => setSex(e.target.value)}
                        />
                        女性
                      </div>
                    </div>
                  </div>
                </div>
                {/* / ラジオボタン */}
                {/* インプット */}
                <div className="p-form-item p-form-item--row">
                  <div className="p-form-item__label">
                    メールアドレス<span className="p-form-item__required">必須</span>
                  </div>
                  <div className="p-form-item__input-container u-gap10 u-sp-gap5">
                    <div className="p-form-item__input-group">
                      <div className="c-input c-input--width272">
                        <input
                          id="email-username"
                          className="c-input__window"
                          type="text"
                          placeholder="fitness"
                          value={emailUsername}
                          onChange={handleEmailUsernameChange}
                          maxLength={60}
                        />
                      </div>
                    </div>
                    <div className="p-form-item__input-group">
                      <div className="p-form-item__sub-label p-form-item__sub-label--auto">@</div>
                      <div className="c-input c-input--width272">
                        <input
                          id="email-domain"
                          className="c-input__window"
                          type="text"
                          placeholder="xxxxxxx.co.jp"
                          value={emailDomain}
                          onChange={handleEmailDomainChange}
                          maxLength={60}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="p-form-item__label" style={{ height: 'auto' }} />
                  <div className="p-form-item__input-container u-gap10 u-sp-gap5">
                    <div
                      style={{
                        color: '#d60035',
                        textAlign: 'start',
                        width: '100%',
                        whiteSpace: 'break-spaces',
                        wordBreak: 'break-word',
                      }}
                    >
                      {mailMessage}
                    </div>
                  </div>
                </div>
                {/* / インプット */}
                {/* インプット */}
                <div className="p-form-item p-form-item--row">
                  <div className="p-form-item__label">
                    連絡先電話番号<span className="p-form-item__required">必須</span>
                  </div>
                  <div className="c-input c-input--width255">
                    <input
                      id="phone-number"
                      className="c-input__window"
                      type="text"
                      placeholder="00000000000"
                      value={telephone}
                      onChange={handleTelephoneChange}
                      maxLength={11}
                    />
                  </div>
                  <div className="p-form-item__label" style={{ height: 'auto' }} />
                  <div
                    style={{
                      color: '#d60035',
                      textAlign: 'start',
                      width: '100%',
                      whiteSpace: 'break-spaces',
                      wordBreak: 'break-all',
                    }}
                  >
                    {telephoneMessage}
                  </div>
                  <div className="p-form-item__label" style={{ height: 'auto' }} />
                  <p className="p-form-item__note">※記入例：08012345678</p>
                </div>
                {/* / インプット */}
              </div>
            </div>
          </section>
          <section className="p-agree">
            <div className="p-agree__container">
              <div className="p-agree__gray-box">
                <div className="c-check-box p-agree__check-box">
                  <input
                    id="privacy-policy"
                    className="c-check-box__input"
                    type="checkbox"
                    name="policy-check"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                  />
                  <button
                    type="button"
                    onClick={handleOpenPolicyModal}
                    className="p-agree__link"
                    style={{
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      cursor: 'pointer',
                      display: 'inline',
                      fontWeight: '700',
                    }}
                  >
                    プライバシーポリシー
                  </button>
                  に同意します
                </div>
              </div>
              <p className="p-agree__text p-agree__text--red">
                上記の「同意します」欄にチェックをして、「次へ」ボタンを押してください。
              </p>
            </div>
          </section>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <div
              style={{
                color: '#d60035',
                textAlign: 'start',
                whiteSpace: 'break-spaces',
                wordBreak: 'break-word',
              }}
            >
              {checkMessage}
            </div>
            <section
              className="p-button-area"
              style={{ width: '100%', minHeight: 'auto', padding: '0', margin: '20px 0 80px 0' }}
            >
              <button
                type="button"
                className="c-button c-button--secondary c-button--large c-button--prev-gray"
                onClick={handleGoBack}
              >
                戻る
              </button>
              <button
                type="button"
                className="c-button c-button--primary c-button--large c-button--next"
                onClick={handleNext}
                disabled={!isNextButtonEnable}
              >
                次へ
              </button>
            </section>
          </div>
        </main>

        <Modal
          show={isModalOpen}
          onHide={onModalCancel}
          animation
          className="p-modal-member"
          dialogClassName="p-modal-member__dialog p-modal-member__dialog--width880 p-modal-member__dialog--height-center reservation-cancel-mdl"
          contentClassName="p-modal-member__content"
        >
          <Modal.Body className="p-modal-member__body">
            <div className="p-modal-member__container">
              <div className="p-modal-member__header">
                <div className="p-modal-member__title p-modal-member__title--padding">{blackListCheckMessage}</div>
              </div>
            </div>
            <div className="p-modal-member__button-area">
              <button type="button" className=" c-button c-button--secondary c-button--large" onClick={onModalCancel}>
                はい
              </button>
              <button type="button" className="c-button c-button--primary c-button--large" onClick={onModalConfirm}>
                いいえ
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </MyPageLayout>
      <VisitorRegisterPolicyModal isOpen={isPolicyModalOpen} onClose={handleClosePolicyModal} />
    </>
  );
};

export default VisitorRegister;
